module.exports = __webpack_public_path__ + "img/MUSA-6.715d42a0.jpg";